import { Component } from '@angular/core';
import { TranslocoModule } from "@ngneat/transloco";
import {
  SearchBarInterceptorComponent
} from "../../../../../widgets/search-bar-interceptor/search-bar-interceptor.component";
import {SeatBookingComponent} from "../seat-booking/seat-booking.component";

@Component({
    selector: 'app-header-cathay',
    templateUrl: './header.component.html',
    styleUrl: './header.component.scss',
    imports: [
        TranslocoModule,
        SearchBarInterceptorComponent,
        SeatBookingComponent,
    ]
})
export class HeaderComponent {


}
